module.exports = __webpack_public_path__ + "static/media/donate1.62b01316.jpg";